import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import { nationsList } from '../../hooks/actions/users';
import { GREEN_LOGO, GREEN_MAIN } from '../../theme/colors';

interface SearchNationsProps {
  setNazione: (value: string) => void;
  disable?: boolean;
  nazione: string
  label: string;
  error?: boolean;
  setError?: React.Dispatch<React.SetStateAction<boolean>>;
  required?: boolean;
}

const SearchNations: React.FC<SearchNationsProps> = ({ setNazione, nazione, disable = true, label, setError, error, required=true}) => {
    const { t } = useTranslation();
    const [nations, setNations] = React.useState<string[]>([])

    React.useEffect(()=>{
      nationsList().then(result => {
        setNations(result)
      }).catch(e=>{
        setNations([]);
      })
    },[])

    return (
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={nations}
        clearOnEscape
        onFocus= {
          () => {
            if(setError)
              setError(false)
          }
        }
        onChange = {
          (event, newValue) => {
            setNazione(newValue as string); 
          }
        }
        onBlur={()=>{
          if(setError){
            if(nazione === '')
              setError(true)
            else
            setError(false);
          }          
        }}
        value={nazione}
        disabled={disable}
        renderInput={(params) => <TextField 
              margin="normal" 
              {...params} 
              required={required}
              id={label}
              name={label}
              autoComplete={label}
              label={label} 
              disabled={disable}
              error={error!}
              helperText={
                error ? t("Selezione obbligatoria") : ""
              }
              sx={{
                marginBottom:0,
                marginTop:0,
                '& .MuiOutlinedInput-notchedOutline': {
                    // borderColor: GREEN_LOGO,
                    color: GREEN_MAIN,
                },
                '& .MuiInputLabel-root': {
                    top: -4,
                    fontSize: '1rem',
                    //color: GREEN_MAIN,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                    color: GREEN_MAIN,
                },
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: GREEN_LOGO,
                    color: GREEN_MAIN,
                },
                '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'grey !important',
                },
                '& .MuiOutlinedInput-input': {
                    padding: '12px 12px',
                    lineHeight: 1.4,
                    color: "grey",
                    fontSize: '1rem',
                    textTransform: 'uppercase'
                },
              }}
            />
          }
        />
    );
  }

  export default SearchNations;